import { render } from "./RestorePage.vue?vue&type=template&id=323d109c&scoped=true"
import script from "./RestorePage.vue?vue&type=script&lang=js"
export * from "./RestorePage.vue?vue&type=script&lang=js"

import "./RestorePage.vue?vue&type=style&index=0&id=323d109c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-323d109c"]])

export default __exports__